<template>
	<div class="push-message">
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left line-banner__list__summary">
					등록: {{ total }}건
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>번호</th>
						<th>푸시내용</th>
						<th>분류</th>
						<th>OS</th>
						<th>상태</th>
						<th>삭제</th>
						<th>등록일</th>
						<th>관리자명</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in list" :key="index">
						<td>{{ item.idMessage }}</td>
						<td class="push-message__cont">
							{{ item.messageText }}
						</td>
						<td>
							<div class="push-message__version">
								<span>업데이트</span>
								<span v-if="item.iosVersion"
									>IOS: {{ item.iosVersion }}</span
								>
								<span v-if="item.androidVersion"
									>AOS: {{ item.androidVersion }}</span
								>
								<div
									class="push-message__type"
									v-if="
										!(
											item.iosVersion ||
											item.androidVersion
										)
									"
								>
									<span>IOS: </span>
									<span>AOS:</span>
								</div>
							</div>
						</td>
						<td class="push-message__os">
							<span
								v-if="item.iosVersion"
								class="psuh-message__os-item"
								>IOS</span
							>
							<span
								v-if="item.androidVersion"
								class="psuh-message__os-item"
								>AOS</span
							>
							<span
								v-if="
									(item.androidVersion && item.iosVersion) ||
									(!item.androidVersion && !item.iosVersion)
								"
								class="psuh-message__os-item"
								>IOS + AOS</span
							>
						</td>
						<td>
							<div class="push-message__status">
								<select
									class="select"
									v-model="item.messageState"
								>
									<option
										v-for="item in statusOptions"
										:key="item.id"
										:value="item.id"
									>
										{{ item.value }}
									</option>
								</select>
								<button
									class="btn blue"
									@click="
										modifyText(index, item.messageState)
									"
								>
									수정
								</button>
							</div>
						</td>
						<td>
							<button
								class="btn red"
								@click="deleteText(item.idMessage)"
							>
								삭제
							</button>
						</td>
						<td>{{ item.createdAt }}</td>
						<td>{{ item.nickName }}</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				:totalItem="total"
				:limit="limit"
				:offset="offset"
				@to="onPagination($event.offset)"
				slot="pagination"
			/>
		</ManagingSection>
	</div>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SelectBox from '@/components/SelectBox.vue';
	import { formattedDate } from '@/util';
	import RadioList from '../../components/RadioList.vue';

	export default {
		components: {
			ManagingSection,
			PaginationBox,
			SelectBox,
			RadioList,
		},
		data() {
			return {
				limit: 10,
				offset: 0,
				total: 0,
				list: [],
				statusOptions: [
					{ id: '0', value: '진행대기' },
					{ id: '1', value: '진행중' },
					{ id: '2', value: '진행중지' },
				],
			};
		},
		created() {
			this.limit = this.$route.query.limit || 10;
			this.offset = this.$route.query.offset || 0;
			this.getList();
		},
		methods: {
			async getList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/operation/app-message/list?limit=${this.limit}&offset=${this.offset}`
					);
					this.total = data.contentTotal;
					this.list = data.data.map(item => {
						return {
							...item,
							createdAt: formattedDate(item.createDate),
						};
					});
				} catch (error) {
					console.error(error);
					alert(
						'리스트를 불러오는것을 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요'
					);
				}
			},
			onPagination(offset) {
				this.offset = offset;
				this.getList();
				this.setQuery();
			},
			async modifyText(index, status) {
				try {
					const item = this.list[index];
					await this.$axiosAdmin2.put(`/api/operation/app-message`, {
						idMessage: item.idMessage,
						messageState: status,
					});
					alert('수정되었습니다');
					this.getList();
				} catch (error) {
					console.error(error);
					alert(
						'수정하는데 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요'
					);
				}
			},
			async deleteText(id) {
				if (confirm('정말 삭제하시겠습니까?')) {
					try {
						await this.$axiosAdmin2.delete(
							`/api/operation/app-message/${id}`
						);
						alert('삭제되었습니다');
						this.getList();
					} catch (error) {
						console.error(error);
						alert(
							'삭제하는데 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요'
						);
					}
				}
			},
			setQuery() {
				this.$router.push({
					query: {
						limit: this.limit,
						offset: this.offset,
					},
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.push-message {
		&__cont {
			width: 50%;
			text-align: left;
			padding: 0 30px;
		}
		&__version {
			width: 100%;
			display: flex;
			flex-direction: column;

			span {
				margin: 5px 0;
			}
		}

		&__type {
			display: flex;
			flex-direction: column;
		}

		&__status {
			display: flex;
			align-items: center;
			justify-content: center;
			select {
				margin-right: 10px;
			}
		}
	}
</style>
